export enum PlanType {
    Equal,
    Percent,
    Increment
}